import api from "./api";
import authHeader from "./auth-header";

const exportAttendance = (startDate, endDate, employeeId = null, includeWorkplace = false) => {
    const params = {
        from: startDate.toISOString(),
        to: endDate.toISOString(),
        includeWorkplace,
    };
    
    if (employeeId) {
        params.employeeId = employeeId;
    }
    
    return api.get("/export/attendance", {
        headers: authHeader(),
        params,
        responseType: 'blob', // Important for handling file downloads
    });
};

const ExportService = {
    exportAttendance,
};

export default ExportService; 